export function initCursorButtonWrapper() {
  const projectLists = document.querySelectorAll('.projects_list');
  if (!projectLists.length) return;

  projectLists.forEach((list) => {
    const cursorWrapper = list.querySelector('.cursor-button-wrapper');
    const projectItems = list.querySelectorAll('.project_list-item');
    if (!cursorWrapper || !projectItems.length) return;

    let frameId = null;
    let targetPosition = null;
    let currentPosition = null;
    let clearEvenStateTimeoutId = null;
    let scrollTimeoutId = null;

    const clearEvenState = () => {
      if (clearEvenStateTimeoutId !== null) {
        window.clearTimeout(clearEvenStateTimeoutId);
        clearEvenStateTimeoutId = null;
      }
    };

    const clearScrollTimeout = () => {
      if (scrollTimeoutId !== null) {
        window.clearTimeout(scrollTimeoutId);
        scrollTimeoutId = null;
      }
    };

    const updatePosition = () => {
      if (!targetPosition) {
        frameId = null;
        return;
      }

      if (!currentPosition) {
        currentPosition = { ...targetPosition };
      } else {
        currentPosition.x += (targetPosition.x - currentPosition.x) * 0.18;
        currentPosition.y += (targetPosition.y - currentPosition.y) * 0.18;
      }

      cursorWrapper.style.setProperty('--cursor-button-x', `${currentPosition.x}px`);
      cursorWrapper.style.setProperty('--cursor-button-y', `${currentPosition.y}px`);

      const distanceX = Math.abs(targetPosition.x - currentPosition.x);
      const distanceY = Math.abs(targetPosition.y - currentPosition.y);

      if (distanceX < 0.1 && distanceY < 0.1) {
        currentPosition = { ...targetPosition };
        cursorWrapper.style.setProperty('--cursor-button-x', `${currentPosition.x}px`);
        cursorWrapper.style.setProperty('--cursor-button-y', `${currentPosition.y}px`);
        frameId = null;
        return;
      }

      frameId = window.requestAnimationFrame(updatePosition);
    };

    const queuePositionUpdate = (event) => {
      const bounds = list.getBoundingClientRect();

      targetPosition = {
        x: event.clientX - bounds.left,
        y: event.clientY - bounds.top
      };

      if (!currentPosition) {
        currentPosition = { ...targetPosition };
        cursorWrapper.style.setProperty('--cursor-button-x', `${currentPosition.x}px`);
        cursorWrapper.style.setProperty('--cursor-button-y', `${currentPosition.y}px`);
      }

      if (frameId === null) {
        frameId = window.requestAnimationFrame(updatePosition);
      }
    };

    projectItems.forEach((item, index) => {
      item.addEventListener('pointerenter', (event) => {
        clearEvenState();
        clearScrollTimeout();
        list.classList.remove('is-cursor-scrolling');
        list.classList.toggle('is-cursor-even', (index + 1) % 2 === 0);
        list.classList.add('is-cursor-active');
        queuePositionUpdate(event);
      });

      item.addEventListener('pointermove', queuePositionUpdate);

      item.addEventListener('pointerleave', () => {
        if (!list.matches(':hover')) {
          list.classList.remove('is-cursor-active');
        }
      });
    });

    list.addEventListener('pointerleave', () => {
      clearScrollTimeout();
      list.classList.remove('is-cursor-scrolling');
      list.classList.remove('is-cursor-active');
      targetPosition = null;
      currentPosition = null;

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
        frameId = null;
      }

      clearEvenState();
      clearEvenStateTimeoutId = window.setTimeout(() => {
        list.classList.remove('is-cursor-even');
        clearEvenStateTimeoutId = null;
      }, 260);
    });

    window.addEventListener(
      'scroll',
      () => {
        if (!list.classList.contains('is-cursor-active')) return;

        clearScrollTimeout();
        list.classList.add('is-cursor-scrolling');
        list.classList.remove('is-cursor-active');

        scrollTimeoutId = window.setTimeout(() => {
          if (list.matches(':hover') && targetPosition) {
            list.classList.remove('is-cursor-scrolling');
            list.classList.add('is-cursor-active');
          } else {
            list.classList.remove('is-cursor-scrolling');
          }

          scrollTimeoutId = null;
        }, 180);
      },
      { passive: true }
    );
  });
}
